import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface CreateEmailRecipientInterface {
  partnerId?: string
  serviceName?: string
  serviceNameDescription?: string
  tag?: string
  recipientEmail?: string
  isActive?: boolean
}

export const useCreateEmailRecipient = () => {
  const mutate = useMutation(
    ({
      partnerId,
      serviceName,
      serviceNameDescription,
      tag,
      recipientEmail,
      isActive,
    }: CreateEmailRecipientInterface) => {
      return postAPI('/NotificationRecipient', {
        recipient: {
          partnerId: partnerId,
          serviceName: serviceName,
          serviceNameDescription: serviceNameDescription,
          tag: tag,
          recipientEmail: recipientEmail,
          isActive: isActive,
        },
      })
    },
  )

  return mutate
}

export default useCreateEmailRecipient
